import lottie, { AnimationItem } from 'lottie-web'
import { useEffect, useRef } from 'react'
import { AnimationWrap } from './Styled'

export interface AnimationProps {
  animationData: any
  paused?: boolean
  pausedAt?: number
  [key: string]: any
}

const Animation = ({ animationData: animationDataI, paused = false, pausedAt = 0, ...props }: AnimationProps) => {
  const animationDataRef = useRef<any>(null)
  if (!animationDataRef.current) {
    animationDataRef.current = JSON.parse(JSON.stringify(animationDataI))
  }
  const animationData = animationDataRef.current
  const ref = useRef<HTMLDivElement | null>(null)
  const animationInst = useRef<AnimationItem | null>(null)

  useEffect(() => {
    if (ref.current) {
      const animation = lottie.loadAnimation({
        container: ref.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      })

      animationInst.current = animation

      return () => {
        animation.destroy()
        animationInst.current = null
      }
    }
    // IT IS INTENTIONAL TO MISS active HERE, DO NOT ADD
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationData])

  useEffect(() => {
    // console.log('run', animationInst.current, animationInst.current.isPaused, paused)
    if (animationInst.current && animationInst.current.isPaused !== paused) {
      if (paused) {
        console.log('paused')
        animationInst.current.pause()
        animationInst.current.goToAndStop(pausedAt, false)
      } else {
        console.log('play')
        animationInst.current.play()
      }
    }
  }, [paused, pausedAt])

  return <AnimationWrap {...props} ref={ref} />
}

export default Animation
